/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Suspense, useEffect, useRef } from 'react'
import { Redirect, Route, Switch, useLocation } from 'react-router-dom'
import { CContainer } from '@coreui/react-pro'
// routes config
import moment from 'moment'
import OLoadingSpinner from './ReusableComponent/OLoadingSpinner'
import routes from '../routes'
import { LoadingType } from '../types/Components/loadingScreenTypes'
import { reduxServices } from '../reducers/reduxServices'
import { useAppDispatch, useTypedSelector } from '../stateStore'
import { CandidateInterviewListRouteLogic } from '../pages/Recruitment/CandidateList/CandidateInterviewList/CandidateInterviewList'
import { CandidateListRouteLogic } from '../pages/Recruitment/CandidateList/CandidateList'
import { AccessCardRouteLogic } from '../pages/EmployeeDirectory/AccessCardList/AccessCardDetails'
import { currentMonthDateNew, previousMonthNew } from '../utils/helper'

const AppContent = () => {
  const dispatch = useAppDispatch()
  const location = useLocation()
  const variable = 'Current Month'
  const prevPathRef = useRef<string>('')

  useEffect(() => {
    const compliancePaths = [
      '/ComplianceReminder',
      '/AddNewCompliance',
      '/EditCompliance',
      '/HistoryCompliance',
    ]
    const isComplianceRoute = (path: string) =>
      compliancePaths.some((p) => path.startsWith(p))

    const prev = prevPathRef.current
    const current = location.pathname
    if (prev && isComplianceRoute(prev) && !isComplianceRoute(current)) {
      // Leaving compliance module -> clear redux cache + localStorage filters
      dispatch(reduxServices.ComplianceReminder.actions.clearPaginationCache())
      try {
        localStorage.removeItem('complianceReminderFiltersV1')
      } catch {
        /* ignore */
      }
    }
    prevPathRef.current = current
  }, [location.pathname, dispatch])
  useEffect(() => {
    if (location.pathname !== '/' && location.pathname.startsWith('/')) {
      localStorage.removeItem('smin')
      dispatch(reduxServices.app.actions.toggleFoldable())
    }
  }, [location.pathname])

  // IT SHOULD BE LIKE THIS
  CandidateInterviewListRouteLogic()
  CandidateListRouteLogic()
  AccessCardRouteLogic()
  // ALL LOGIC BELOW SHOULD BE A CUSTOM HOOK

  const getPIPDateValue = useTypedSelector(
    reduxServices.pipList.selectors.getDateValue,
  )

  const getSelectedMonthValue = useTypedSelector(
    reduxServices.resignationList.selectors.getSelectedMonthValue,
  )
  const getSelectedStatusValue = useTypedSelector(
    reduxServices.resignationList.selectors.getSelectedStatusValue,
  )
  const getSelectedEmployeeStatusValue = useTypedSelector(
    reduxServices.resignationList.selectors.getSelectedEmployeeStatusValue,
  )

  const fromDateValue = useTypedSelector(
    reduxServices.pipList.selectors.getFromDateValue,
  )
  const toDateValue = useTypedSelector(
    reduxServices.pipList.selectors.getToDateValue,
  )

  // TODO: REFACTOR THIS PLEASE!!!

  // What the hell is this?!?!?!?
  // WHY ARE WE DOING ROUTE LOGIC HERE?
  // TOO MANY USEEFFECTS AND USESELECTORS
  // THIS IS A MESS
  // IT WOULD HAVE BEEN OKAY IF WE HAD A SINGLE USEEFFECT AND THE FILTERS WERE IN A SINGLE OBJECT
  useEffect(() => {
    // conditions like this can just be made as a function and called here
    // same with other conditions
    if (
      location.pathname === '/PIPList' ||
      location.pathname === '/PIPClearnceCerticates' ||
      location.pathname.split('/')[1] === 'ViewPIPDetail'
    ) {
      dispatch(reduxServices.pipList.actions.setDate(getPIPDateValue))
      dispatch(reduxServices.pipList.actions.setFromDate(fromDateValue))
      dispatch(reduxServices.pipList.actions.setToDate(toDateValue))
    } else {
      dispatch(reduxServices.pipList.actions.setDate(variable))
      dispatch(reduxServices.pipList.actions.setFromDate(''))
      dispatch(reduxServices.pipList.actions.setToDate(''))
    }
  }, [dispatch, location, getPIPDateValue, fromDateValue, toDateValue])

  const getFromDateValue = useTypedSelector(
    reduxServices.resignationList.selectors.getFromDateValue,
  )
  const getToDateValue = useTypedSelector(
    reduxServices.resignationList.selectors.getToDateValue,
  )

  useEffect(() => {
    if (
      location.pathname === '/resignationList' ||
      location.pathname === '/managerComments' ||
      location.pathname === '/separationChart' ||
      location.pathname === '/ClearanceCertificateIT' ||
      location.pathname === '/ClearanceCertificateFinance' ||
      location.pathname === '/ClearanceCertificateAdmin' ||
      location.pathname === '/ClearanceCertificateHR' ||
      location.pathname === '/ExitFeedBackForm' ||
      location.pathname === '/ClearanceCertificateManager'
    ) {
      dispatch(
        reduxServices.resignationList.actions.setMonthValue(
          getSelectedMonthValue,
        ),
      )
      dispatch(
        reduxServices.resignationList.actions.setStatusValue(
          getSelectedStatusValue,
        ),
      )
      dispatch(
        reduxServices.resignationList.actions.setEmployeeStatusValue(
          getSelectedEmployeeStatusValue,
        ),
      )
      dispatch(
        reduxServices.resignationList.actions.setFromDate(getFromDateValue),
      )
      dispatch(reduxServices.resignationList.actions.setToDate(getToDateValue))
    } else {
      dispatch(reduxServices.resignationList.actions.setMonthValue(''))
      dispatch(reduxServices.resignationList.actions.setStatusValue('All'))
      dispatch(reduxServices.resignationList.actions.setEmployeeStatusValue(''))
      dispatch(reduxServices.resignationList.actions.setFromDate(''))
      dispatch(reduxServices.resignationList.actions.setToDate(''))
    }
  }, [
    dispatch,
    location,
    getPIPDateValue,
    getSelectedStatusValue,
    getSelectedEmployeeStatusValue,
    getFromDateValue,
    getToDateValue,
  ])
  const TicketStatusValue = useTypedSelector(
    reduxServices.ticketApprovals.selectors.TicketStatusValue,
  )
  const ApprovalStatusValue = useTypedSelector(
    reduxServices.ticketApprovals.selectors.ApprovalStatusValue,
  )
  const DateValue = useTypedSelector(
    reduxServices.ticketApprovals.selectors.DateValue,
  )
  const TrackerValue = useTypedSelector(
    reduxServices.ticketApprovals.selectors.TrackerValue,
  )
  const DepartmentNameValue = useTypedSelector(
    reduxServices.ticketApprovals.selectors.DepartmentNameValue,
  )
  const CategoryNameValue = useTypedSelector(
    reduxServices.ticketApprovals.selectors.CategoryNameValue,
  )
  const SubCategoryNameValue = useTypedSelector(
    reduxServices.ticketApprovals.selectors.SubCategoryNameValue,
  )
  const FormDateValue = useTypedSelector(
    reduxServices.ticketApprovals.selectors.FormDateValue,
  )
  const ToDateValue = useTypedSelector(
    reduxServices.ticketApprovals.selectors.ToDateValue,
  )
  useEffect(() => {
    if (
      location.pathname === '/ticketApprovals' ||
      location.pathname.split('/')[1] === 'updateTicketInApprovals'
    ) {
      dispatch(
        reduxServices.ticketApprovals.actions.setTicketStatusValue(
          TicketStatusValue,
        ),
      )
      dispatch(
        reduxServices.ticketApprovals.actions.setApprovalStatusValue(
          ApprovalStatusValue,
        ),
      )
      dispatch(reduxServices.ticketApprovals.actions.setDateValue(DateValue))
      dispatch(
        reduxServices.ticketApprovals.actions.setTrackerValue(TrackerValue),
      )
      dispatch(
        reduxServices.ticketApprovals.actions.setDepartmentNameValue(
          DepartmentNameValue,
        ),
      )
      dispatch(
        reduxServices.ticketApprovals.actions.setCategoryNameValue(
          CategoryNameValue,
        ),
      )
      dispatch(
        reduxServices.ticketApprovals.actions.setSubCategoryNameValue(
          SubCategoryNameValue,
        ),
      )
      dispatch(
        reduxServices.ticketApprovals.actions.setFormDataValue(FormDateValue),
      )
      dispatch(
        reduxServices.ticketApprovals.actions.setToDateValue(ToDateValue),
      )
    } else {
      dispatch(
        reduxServices.ticketApprovals.actions.setTicketStatusValue('New'),
      )
      dispatch(
        reduxServices.ticketApprovals.actions.setApprovalStatusValue(
          'pending Approval',
        ),
      )
      dispatch(reduxServices.ticketApprovals.actions.setDateValue('Today'))
      dispatch(reduxServices.ticketApprovals.actions.setTrackerValue('All'))
      dispatch(
        reduxServices.ticketApprovals.actions.setDepartmentNameValue('All'),
      )
      dispatch(
        reduxServices.ticketApprovals.actions.setCategoryNameValue('All'),
      )
      dispatch(
        reduxServices.ticketApprovals.actions.setSubCategoryNameValue('All'),
      )
      dispatch(reduxServices.ticketApprovals.actions.setFormDataValue(''))
      dispatch(reduxServices.ticketApprovals.actions.setToDateValue(''))
    }
  }, [
    dispatch,
    location,
    TicketStatusValue,
    ApprovalStatusValue,
    DateValue,
    TrackerValue,
    DepartmentNameValue,
    CategoryNameValue,
    SubCategoryNameValue,
    FormDateValue,
    ToDateValue,
  ])

  const getSelectValue = useTypedSelector(
    reduxServices.projectReport.selectors.getSelectValue,
  )
  const getStatusValue = useTypedSelector(
    reduxServices.projectReport.selectors.getStatusValue,
  )
  const getPricingModel = useTypedSelector(
    reduxServices.projectReport.selectors.getPricingModel,
  )
  const getProjectHealth = useTypedSelector(
    reduxServices.projectReport.selectors.getProjectHealth,
  )
  const getCustomFromValue = useTypedSelector(
    reduxServices.projectReport.selectors.getCustomFromValue,
  )
  const getCustomToValue = useTypedSelector(
    reduxServices.projectReport.selectors.getCustomToValue,
  )
  const getTypeValue = useTypedSelector(
    reduxServices.projectReport.selectors.getTypeValue,
  )

  const secondPart = location.pathname.split('/')[1]
  const finalParts = secondPart.split('/')

  useEffect(() => {
    if (
      location.pathname === '/projectreport' ||
      location.pathname === '/addProject' ||
      location.pathname.split('/')[1] === 'viewProject' ||
      location.pathname.split('/')[1] === 'editproject' ||
      location.pathname.split('/')[1] === 'retainerMilestone' ||
      finalParts[0] === 'editRetainerMilestone' ||
      location.pathname.split('/')[1] === 'milestonehistory' ||
      finalParts[0] === 'milestoneNewsFeed'
    ) {
      dispatch(
        reduxServices.projectReport.actions.setPricingModel(getPricingModel),
      )
      dispatch(
        reduxServices.projectReport.actions.setProjectHealth(getProjectHealth),
      )
      dispatch(
        reduxServices.projectReport.actions.setSelectValue(getSelectValue),
      )
      dispatch(
        reduxServices.projectReport.actions.setStatusValue(getStatusValue),
      )
      dispatch(
        reduxServices.projectReport.actions.setCustomFromValue(
          getCustomFromValue,
        ),
      )
      dispatch(
        reduxServices.projectReport.actions.setCustomToValue(getCustomToValue),
      )
      dispatch(reduxServices.projectReport.actions.setTypeValue(getTypeValue))
    } else {
      // removed this line of code because it is causing the projectReports table to reset when route is coming from outside the declared routes in the above condition.
      // dispatch(reduxServices.projectReport.actions.setProjectHealth('All'))
      // dispatch(reduxServices.projectReport.actions.setPricingModel('All'))
      // dispatch(reduxServices.projectReport.actions.setSelectValue(''))
      // dispatch(reduxServices.projectReport.actions.setStatusValue('INPROGRESS'))
      // dispatch(reduxServices.projectReport.actions.setCustomFromValue(''))
      // dispatch(reduxServices.projectReport.actions.setCustomToValue(''))
      // dispatch(reduxServices.projectReport.actions.setTypeValue('ALL'))
    }
  }, [
    dispatch,
    location,
    getSelectValue,
    getProjectHealth,
    getPricingModel,
    getStatusValue,
    getCustomFromValue,
    getCustomToValue,
    getTypeValue,
  ])

  const getDepartmentName = useTypedSelector(
    reduxServices.ticketReport.selectors.getDepartmentName,
  )
  const getDateValue = useTypedSelector(
    reduxServices.ticketReport.selectors.getDateValue,
  )
  const getFromDate = useTypedSelector(
    reduxServices.ticketReport.selectors.getFromDate,
  )
  const getToDate = useTypedSelector(
    reduxServices.ticketReport.selectors.getToDate,
  )

  useEffect(() => {
    if (location.pathname === '/ticketReport') {
      dispatch(
        reduxServices.ticketReport.actions.setDepartmentName(getDepartmentName),
      )
      dispatch(reduxServices.ticketReport.actions.setDateValue(getDateValue))

      dispatch(reduxServices.ticketReport.actions.setFromDate(getFromDate))

      dispatch(reduxServices.ticketReport.actions.setToDate(getToDate))
    } else {
      dispatch(reduxServices.ticketReport.actions.setDepartmentName('All'))
      dispatch(reduxServices.ticketReport.actions.setDateValue('Today'))

      dispatch(reduxServices.ticketReport.actions.setFromDate(''))

      dispatch(reduxServices.ticketReport.actions.setToDate(''))
    }
  }, [
    dispatch,
    location,
    getDepartmentName,
    getDateValue,
    getFromDate,
    getToDate,
  ])

  const LocationValue = useTypedSelector(
    reduxServices.bookingList.selectors.LocationValue,
  )
  const MeetingStatus = useTypedSelector(
    reduxServices.bookingList.selectors.MeetingStatus,
  )
  const RoomValue = useTypedSelector(
    reduxServices.bookingList.selectors.RoomValue,
  )
  const SelectCustom = useTypedSelector(
    reduxServices.bookingList.selectors.SelectCustom,
  )
  const FromDateValue = useTypedSelector(
    reduxServices.bookingList.selectors.FromDateValue,
  )

  useEffect(() => {
    if (
      location.pathname === '/meetingList' ||
      location.pathname.split('/')[1] === 'MeetingRequestEdit'
    ) {
      dispatch(
        reduxServices.bookingList.actions.setLocationValue(LocationValue),
      )
      dispatch(reduxServices.bookingList.actions.setRoomValue(RoomValue))

      dispatch(
        reduxServices.bookingList.actions.setMeetingStatus(MeetingStatus),
      )

      dispatch(reduxServices.bookingList.actions.setSelectCustom(SelectCustom))
      dispatch(
        reduxServices.bookingList.actions.setFromDateValue(FromDateValue),
      )
    } else {
      dispatch(reduxServices.bookingList.actions.setLocationValue('1'))
      dispatch(reduxServices.bookingList.actions.setRoomValue(''))

      dispatch(reduxServices.bookingList.actions.setMeetingStatus('New'))

      dispatch(reduxServices.bookingList.actions.setSelectCustom('Today'))
      dispatch(reduxServices.bookingList.actions.setFromDateValue(''))
    }
  }, [
    dispatch,
    location,
    LocationValue,
    RoomValue,
    MeetingStatus,
    SelectCustom,
    FromDateValue,
  ])

  const SelectCustomEventList = useTypedSelector(
    reduxServices.eventList.selectors.SelectCustom,
  )
  const FromDateFilter = useTypedSelector(
    reduxServices.eventList.selectors.FromDateFilter,
  )
  const ToDateFilter = useTypedSelector(
    reduxServices.eventList.selectors.ToDateFilter,
  )

  useEffect(() => {
    if (
      location.pathname === '/eventList' ||
      location.pathname.split('/')[1] === 'trainingFeedBackForm' ||
      location.pathname.split('/')[1] === 'editEvent'
    ) {
      dispatch(
        reduxServices.eventList.actions.setFromDateFilter(FromDateFilter),
      )
      dispatch(reduxServices.eventList.actions.setToDateFilter(ToDateFilter))
      dispatch(
        reduxServices.eventList.actions.setSelectCustom(SelectCustomEventList),
      )
    } else {
      dispatch(reduxServices.eventList.actions.setFromDateFilter(''))
      dispatch(reduxServices.eventList.actions.setToDateFilter(''))
      dispatch(reduxServices.eventList.actions.setSelectCustom(variable))
    }
  }, [dispatch, location, getPIPDateValue])

  const getMonthValue = useTypedSelector(
    reduxServices.sqaAuditReport.selectors.getSelectedMonthValue,
  )
  const getStatus = useTypedSelector(
    reduxServices.sqaAuditReport.selectors.getSelectedStatusValue,
  )

  const getSelectedRescheduleStatusValue = useTypedSelector(
    reduxServices.sqaAuditReport.selectors.getSelectedRescheduleStatusValue,
  )
  const getFromValue = useTypedSelector(
    reduxServices.sqaAuditReport.selectors.getFromDateValue,
  )
  const getToValue = useTypedSelector(
    reduxServices.sqaAuditReport.selectors.getToDateValue,
  )
  const getSearchInputValue = useTypedSelector(
    reduxServices.sqaAuditReport.selectors.getSearchInputValue,
  )

  useEffect(() => {
    if (
      location.pathname === '/SQAAudit' ||
      location.pathname.split('/')[1] === 'viewProjectAudit' ||
      location.pathname.split('/')[1] === 'editAuditForm' ||
      location.pathname.split('/')[1] === 'newProjectAuditTimeline'
    ) {
      dispatch(
        reduxServices.sqaAuditReport.actions.setMonthValue(getMonthValue),
      )
      dispatch(reduxServices.sqaAuditReport.actions.setStatusValue(getStatus))
      dispatch(
        reduxServices.sqaAuditReport.actions.setRescheduleStatus(
          getSelectedRescheduleStatusValue,
        ),
      )
      dispatch(
        reduxServices.sqaAuditReport.actions.setSearchInput(
          getSearchInputValue,
        ),
      )
      dispatch(reduxServices.sqaAuditReport.actions.setFromDate(getFromValue))
      dispatch(reduxServices.sqaAuditReport.actions.setToDate(getToValue))
    } else {
      dispatch(reduxServices.sqaAuditReport.actions.setMonthValue(''))
      dispatch(reduxServices.sqaAuditReport.actions.setStatusValue(''))
      dispatch(reduxServices.sqaAuditReport.actions.setRescheduleStatus(''))
      dispatch(reduxServices.sqaAuditReport.actions.setFromDate(''))
      dispatch(reduxServices.sqaAuditReport.actions.setToDate(''))
      dispatch(reduxServices.sqaAuditReport.actions.setSearchInput(''))
    }
  }, [
    dispatch,
    location,
    getMonthValue,
    getStatus,
    getSelectedRescheduleStatusValue,
    getFromValue,
    getToValue,
    getSearchInputValue,
  ])
  // --------------------------------------------------

  const getAssetMonthValue = useTypedSelector(
    reduxServices.assetTransactionList.selectors.getSelectedMonthValue,
  )
  const getSearchByEmployeeValue = useTypedSelector(
    reduxServices.assetTransactionList.selectors.getSearchByEmpNameVal,
  )
  const getAssetStatus = useTypedSelector(
    reduxServices.assetTransactionList.selectors
      .getSelectedAssetStatusFilterValue,
  )

  const getSelectedProductTypeValue = useTypedSelector(
    reduxServices.assetTransactionList.selectors
      .getSelectedProductTypeFilterValue,
  )

  const getSelectedAssetTypeValue = useTypedSelector(
    reduxServices.assetTransactionList.selectors
      .getSelectedAssetTypeFilterValue,
  )
  const getSelectedAssetStatusValue = useTypedSelector(
    reduxServices.assetTransactionList.selectors
      .getSelectedAssetStatusFilterValue,
  )
  const getFromValue1 = useTypedSelector(
    reduxServices.assetTransactionList.selectors.getFromDateValue,
  )
  const getToValue1 = useTypedSelector(
    reduxServices.assetTransactionList.selectors.getToDateValue,
  )
  const getSearchInputValue1 = useTypedSelector(
    reduxServices.assetTransactionList.selectors.getSearchInputFieldValue,
  )

  useEffect(() => {
    if (
      location.pathname === '/transactionalList' ||
      location.pathname.split('/')[1] === 'transactionalList'
    ) {
      dispatch(
        reduxServices.assetTransactionList.actions.setCurrentMonthValue(
          getAssetMonthValue,
        ),
      )
      dispatch(
        reduxServices.assetTransactionList.actions.setSearchByEmployeeVal(
          getSearchByEmployeeValue,
        ),
      )
      dispatch(
        reduxServices.assetTransactionList.actions.setFromDateVal(
          getFromValue1,
        ),
      )
      dispatch(
        reduxServices.assetTransactionList.actions.setToDateVal(getToValue1),
      )
      dispatch(
        reduxServices.assetTransactionList.actions.setAssetTypeFilter(
          getSelectedAssetTypeValue,
        ),
      )
      dispatch(
        reduxServices.assetTransactionList.actions.setProductTypeFilterValue(
          getSelectedProductTypeValue,
        ),
      )
      dispatch(
        reduxServices.assetTransactionList.actions.setStatusFilterValue(
          getSelectedAssetStatusValue,
        ),
      )
      dispatch(
        reduxServices.assetTransactionList.actions.setSearchInputVal(
          getSearchInputValue1,
        ),
      )
    } else {
      dispatch(
        reduxServices.assetTransactionList.actions.setCurrentMonthValue(
          variable,
        ),
      )
      dispatch(
        reduxServices.assetTransactionList.actions.setStatusFilterValue(''),
      )
      dispatch(
        reduxServices.assetTransactionList.actions.setAssetTypeFilter(''),
      )
      dispatch(
        reduxServices.assetTransactionList.actions.setProductTypeFilterValue(
          '',
        ),
      )
      dispatch(reduxServices.assetTransactionList.actions.setFromDateVal(''))
      dispatch(reduxServices.assetTransactionList.actions.setToDateVal(''))
      dispatch(reduxServices.assetTransactionList.actions.setSearchInputVal(''))
    }
  }, [
    dispatch,
    location,
    getAssetMonthValue,
    getAssetStatus,
    getSelectedProductTypeValue,
    getFromValue1,
    getToValue1,
    getSearchInputValue1,
    getSelectedAssetStatusValue,
    getSelectedAssetTypeValue,
    getSearchByEmployeeValue,
  ])
  // -------------------------------------------------------

  const getAssetListMonthValue = useTypedSelector(
    reduxServices.assetList.selectors.getSelectedMonthValue,
  )
  const getSearchByEmployeeName = useTypedSelector(
    reduxServices.assetList.selectors.getSearchByEmpName,
  )
  const getAssetListValue = useTypedSelector(
    reduxServices.assetList.selectors.getAssetListValue,
  )

  const getFilterdProductTypeValue = useTypedSelector(
    reduxServices.assetList.selectors.getSelectedProductTypeValue,
  )

  const getFilterdAssetTypeValue = useTypedSelector(
    reduxServices.assetList.selectors.getSelectedAssetTypeValue,
  )
  const getFilterdAssetStatusValue = useTypedSelector(
    reduxServices.assetList.selectors.getSelectedAsseStatusValue,
  )
  const getAssetListFromValue = useTypedSelector(
    reduxServices.assetList.selectors.getFromDateValue,
  )
  const getAssetListToValue = useTypedSelector(
    reduxServices.assetList.selectors.getToDateValue,
  )
  const getAssetListSearchInputValue = useTypedSelector(
    reduxServices.assetList.selectors.getSearchInputValue,
  )

  useEffect(() => {
    if (location.pathname === '/assetList') {
      dispatch(
        reduxServices.assetList.actions.setMonthValue(getAssetMonthValue),
      )
      dispatch(
        reduxServices.assetList.actions.setSearchByEmployee(
          getSearchByEmployeeName,
        ),
      )
      dispatch(
        reduxServices.assetList.actions.setFromDate(getAssetListFromValue),
      )
      dispatch(reduxServices.assetList.actions.setToDate(getAssetListToValue))
      dispatch(
        reduxServices.assetList.actions.setAssetTypeStatus(
          getFilterdAssetTypeValue,
        ),
      )
      dispatch(
        reduxServices.assetList.actions.setProductTypeStatus(
          getFilterdProductTypeValue,
        ),
      )
      dispatch(
        reduxServices.assetList.actions.setAssetStatusValue(getAssetListValue),
      )
      dispatch(
        reduxServices.assetList.actions.setAssetStatusValue(
          getFilterdAssetStatusValue,
        ),
      )
      dispatch(
        reduxServices.assetList.actions.setSearchInput(
          getAssetListSearchInputValue,
        ),
      )
    } else {
      dispatch(reduxServices.assetList.actions.setMonthValue(''))
      dispatch(reduxServices.assetList.actions.setAssetStatusValue(''))
      dispatch(reduxServices.assetList.actions.setAssetList(''))
      dispatch(reduxServices.assetList.actions.setAssetTypeStatus(''))
      dispatch(reduxServices.assetList.actions.setProductTypeStatus(''))
      dispatch(reduxServices.assetList.actions.setFromDate(''))
      dispatch(reduxServices.assetList.actions.setToDate(''))
      dispatch(reduxServices.assetList.actions.setSearchInput(''))
    }
  }, [
    dispatch,
    location,
    getAssetListMonthValue,
    getAssetListValue,
    getFilterdProductTypeValue,
    getAssetListFromValue,
    getAssetListToValue,
    getAssetListSearchInputValue,
    getFilterdAssetStatusValue,
    getFilterdAssetTypeValue,
    getSearchByEmployeeName,
  ])

  const departmentNameValue = useTypedSelector(
    reduxServices.paymentList.selectors.departmentNameValue,
  )
  const categoryNameValue = useTypedSelector(
    reduxServices.paymentList.selectors.categoryNameValue,
  )

  const countryValue = useTypedSelector(
    reduxServices.paymentList.selectors.countryValue,
  )

  const modeOfPaymentValue = useTypedSelector(
    reduxServices.paymentList.selectors.modeOfPaymentValue,
  )

  const creditCardsValue = useTypedSelector(
    reduxServices.paymentList.selectors.creditCardsValue,
  )

  const paymentFromDateValue = useTypedSelector(
    reduxServices.paymentList.selectors.getFromDateValue,
  )
  const paymentToDateValue = useTypedSelector(
    reduxServices.paymentList.selectors.getToDateValue,
  )

  const getPaymentDateValue = useTypedSelector(
    reduxServices.paymentList.selectors.getPaymentValue,
  )

  useEffect(() => {
    if (
      location.pathname === '/paymentList' ||
      location.pathname.split('/')[1] === 'paymentForm' ||
      location.pathname.split('/')[1] === 'paymentTimeline'
    ) {
      dispatch(
        reduxServices.paymentList.actions.setDepartmentValue(
          departmentNameValue,
        ),
      )
      dispatch(
        reduxServices.paymentList.actions.setCategoryNameValue(
          categoryNameValue,
        ),
      )
      dispatch(
        reduxServices.paymentList.actions.setCountryNameValue(countryValue),
      )
      dispatch(
        reduxServices.paymentList.actions.setModeOfPaymentValue(
          modeOfPaymentValue,
        ),
      )
      dispatch(
        reduxServices.paymentList.actions.setCreditCardValue(creditCardsValue),
      )
      dispatch(
        reduxServices.paymentList.actions.setFromDate(paymentFromDateValue),
      )
      dispatch(reduxServices.paymentList.actions.setToDate(paymentToDateValue))
      dispatch(
        reduxServices.paymentList.actions.setMonthValue(getPaymentDateValue),
      )
    } else {
      dispatch(reduxServices.paymentList.actions.setDepartmentValue(''))
      dispatch(reduxServices.paymentList.actions.setCategoryNameValue(''))
      dispatch(reduxServices.paymentList.actions.setCountryNameValue(''))
      dispatch(reduxServices.paymentList.actions.setModeOfPaymentValue(''))
      dispatch(reduxServices.paymentList.actions.setCreditCardValue(''))
      dispatch(reduxServices.paymentList.actions.setFromDate(''))
      dispatch(reduxServices.paymentList.actions.setToDate(''))
      dispatch(reduxServices.paymentList.actions.setMonthValue(''))
    }
  }, [
    dispatch,
    departmentNameValue,
    categoryNameValue,
    countryValue,
    modeOfPaymentValue,
    creditCardsValue,
    paymentFromDateValue,
    paymentToDateValue,
    getPaymentDateValue,
  ])

  const getTicketConfigurationDepartment = useTypedSelector(
    reduxServices.ticketConfiguration.selectors.departmentState,
  )

  const getTicketConfigurationCategory = useTypedSelector(
    reduxServices.ticketConfiguration.selectors.categoryNameState,
  )

  const getTicketConfigurationSubCategory = useTypedSelector(
    reduxServices.ticketConfiguration.selectors.subCategoryState,
  )

  useEffect(() => {
    if (location.pathname === '/subCategoryList') {
      dispatch(
        reduxServices.ticketConfiguration.actions.setDepartmentValue(
          getTicketConfigurationDepartment,
        ),
      )
      dispatch(
        reduxServices.ticketConfiguration.actions.setCategoryName(
          getTicketConfigurationCategory,
        ),
      )
      dispatch(
        reduxServices.ticketConfiguration.actions.setSubCategoryName(
          getTicketConfigurationSubCategory,
        ),
      )
    } else {
      dispatch(reduxServices.ticketConfiguration.actions.setDepartmentValue(''))
      dispatch(reduxServices.ticketConfiguration.actions.setCategoryName(''))
      dispatch(reduxServices.ticketConfiguration.actions.setSubCategoryName(''))
    }
  }, [
    dispatch,
    getTicketConfigurationDepartment,
    getTicketConfigurationCategory,
    getTicketConfigurationSubCategory,
  ])

  // Attendance Report

  const getBiometricValue = useTypedSelector(
    reduxServices.employeeAttendanceReport.selectors.getBiometric,
  )

  const getSearchValue = useTypedSelector(
    reduxServices.employeeAttendanceReport.selectors.getSearchValue,
  )

  const getEmployeeStatusValue = useTypedSelector(
    reduxServices.employeeAttendanceReport.selectors.employeeStatus,
  )

  const getEmployeeShift = useTypedSelector(
    reduxServices.employeeAttendanceReport.selectors.getEmployeeShift,
  )
  const getIsOther = useTypedSelector(
    reduxServices.employeeAttendanceReport.selectors.isOther,
  )
  const dateValue = useTypedSelector(
    reduxServices.employeeAttendanceReport.selectors.date,
  )
  const monthDisplay = useTypedSelector(
    reduxServices.employeeAttendanceReport.selectors.monthDisplay,
  )
  const getMonthSelection = useTypedSelector(
    reduxServices.employeeAttendanceReport.selectors.getMonthSelection,
  )

  const getPaginationCache = useTypedSelector(
    reduxServices.employeeAttendanceReport.selectors.getPaginationCache,
  )

  const setMonthDisplayByCountry = (
    country: string | null,
    dispatch: any,
  ): string => {
    const dateValue = currentMonthDateNew(country ?? '')
    const [month, year] = (dateValue || '').split('/').map(Number)
    const formattedDate = moment({ year, month, day: 1 }).format('MMMM-YYYY')

    dispatch(
      reduxServices.employeeAttendanceReport.actions.setMonthDisplay(
        formattedDate,
      ),
    )

    return dateValue
  }

  useEffect(() => {
    const monthSelection = (() => {
      // If getMonthSelection is valid (not null or undefined), use it
      if (getMonthSelection) {
        return getMonthSelection
      } else {
        // Otherwise, fallback to your desired logic (e.g., currentMonth or previousMonth logic)
        const storedCountry = localStorage.getItem('employeeCountry')
        const currentMonthValue = currentMonthDateNew(storedCountry ?? '')
        if (currentMonthValue) {
          return Number(currentMonthValue.split('/')[0])
        } else {
          const previousMonthValue = previousMonthNew(storedCountry ?? '')
          return Number(previousMonthValue.split('/')[0])
        }
      }
    })()

    if (
      location.pathname === '/attendancesummary' ||
      location.pathname === '/lateArrivalReport'
    ) {
      dispatch(
        reduxServices.employeeAttendanceReport.actions.setBiometric(
          getBiometricValue,
        ),
      )
      dispatch(
        reduxServices.employeeAttendanceReport.actions.setSearchValue(
          getSearchValue,
        ),
      )
      dispatch(
        reduxServices.employeeAttendanceReport.actions.setEmployeeStatus(
          getEmployeeStatusValue,
        ),
      )
      dispatch(
        reduxServices.employeeAttendanceReport.actions.setEmployeeShift(
          getEmployeeShift,
        ),
      )
      dispatch(
        reduxServices.employeeAttendanceReport.actions.setIsOther(getIsOther),
      )
      dispatch(
        reduxServices.employeeAttendanceReport.actions.setDate(dateValue),
      )
      dispatch(
        reduxServices.employeeAttendanceReport.actions.setMonthDisplay(
          monthDisplay,
        ),
      )
      dispatch(
        reduxServices.employeeAttendanceReport.actions.setMonthSelection(
          monthSelection,
        ),
      )
      dispatch(
        reduxServices.employeeAttendanceReport.actions.setPaginationCache(
          getPaginationCache,
        ),
      )
    } else {
      const storedCountry = localStorage.getItem('employeeCountry')
      const currentMonthValue = setMonthDisplayByCountry(
        storedCountry,
        dispatch,
      )
      const fallbackMonthSelection = currentMonthValue
        ? Number(currentMonthValue.split('/')[0])
        : 0 // fallback to 0 if needed

      dispatch(reduxServices.employeeAttendanceReport.actions.setBiometric(''))
      dispatch(
        reduxServices.employeeAttendanceReport.actions.setSearchValue(''),
      )
      dispatch(
        reduxServices.employeeAttendanceReport.actions.setEmployeeStatus(
          'Active',
        ),
      )
      dispatch(
        reduxServices.employeeAttendanceReport.actions.setEmployeeShift(''),
      )
      dispatch(reduxServices.employeeAttendanceReport.actions.setIsOther(''))
      dispatch(reduxServices.employeeAttendanceReport.actions.setDate(''))
      dispatch(
        reduxServices.employeeAttendanceReport.actions.setMonthSelection(
          fallbackMonthSelection,
        ),
      )
      dispatch(
        reduxServices.employeeAttendanceReport.actions.setPaginationCache({
          currentPage: 0,
          pageSize: 20,
        }),
      )
    }
  }, [
    dispatch,
    getBiometricValue,
    getSearchValue,
    getEmployeeStatusValue,
    getEmployeeShift,
    getIsOther,
    dateValue,
    monthDisplay,
    getMonthSelection,
    location.pathname,
  ])
  return (
    <CContainer fluid>
      <Suspense fallback={<OLoadingSpinner type={LoadingType.PAGE} />}>
        <Switch>
          {routes.map((route, idx) => {
            return (
              route.component && (
                <Route
                  key={idx}
                  path={route.path}
                  exact={route.exact}
                  render={() => (
                    <>
                      <route.component />
                    </>
                  )}
                />
              )
            )
          })}
          <Redirect from="/" to="/login" />
        </Switch>
      </Suspense>
    </CContainer>
  )
}

export default React.memo(AppContent)
